import React, {useState, useEffect} from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputText from '../FormFields/InputText';
import SelectInfinite from '../FormFields/SelectInfinite';
import TextArea from '../FormFields/Textarea';
import {getLanguage, t} from 'react-switch-lang';
import * as yup from 'yup';
import {useForm, FormProvider} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import Toast from '../toast/Toast';
import PreventTransitionPrompt from '../preventTransitionprompt/PreventTransition';
import SelectList from '../../components/FormFields/select/SelectList';
import {Spin} from 'antd';
import {addControl} from "../../services/controlsService/controlsApi";
import {purposeOptions,controlFrequencyOptions,controlTypeOptions,controlAssessmentOptions} from "../../utils/controlsConstants";
import {appModules} from '../../utils/const';

function ControlsFormAdd({
                             riskTitle, toggleOpen, departmentData, open, id
                         }) {

    const [loading, setLoading] = useState(false);
    const [disableBtn, setDisableBtn] = useState(false);
    const [isAdding, setIsAdding] = useState(true);
    const lang = getLanguage();


    const [schema, setScheme] = useState(yup.object().shape({
        name: yup
            .string()
            .nullable()
            .trim()
            .required(t('message.fieldRequired'))
            .max(250, t('message.max', {max: 250})),
        description: yup
            .string()
            .nullable()
            .trim()
            .required(t('message.fieldRequired'))
            .max(1000, t('message.max', {max: 1000})),
        purpose: yup
            .object()
            .nullable()
            .required(t('message.fieldRequired')),
        type: yup
            .object()
            .nullable()
            .required(t('message.fieldRequired')),
        frequency: yup
            .object()
            .nullable()
            .required(t('message.fieldRequired')),
        evidence: yup
            .string()
            .nullable()
            .trim()
            .required(t('message.fieldRequired'))
           .max(1000, t('message.max', {max: 1000})),
        controlAssessment: yup
            .object()
            .nullable()
            .required(t('message.fieldRequired')),
        department: yup.object().nullable().required(t('message.fieldRequired')),
    }));

    const l = getLanguage();


    const methods = useForm({
        resolver: yupResolver(schema),
    });

    const {handleSubmit, watch, errors, setValue} = methods;
    const submitForm = async (submitedData) => {
        setDisableBtn(true);
        const payload = {
            name: submitedData.name,
            description: submitedData.description,
            purpose: submitedData.purpose.value,
            type: submitedData.type.value,
            frequency: submitedData.frequency.value,
            evidence: submitedData.evidence,
            controlAssessment: submitedData.controlAssessment.value,
            department: {id: submitedData.department.value, name: submitedData.department.label},
            risk: {id: id, name: riskTitle}
        };
        try {
            const response = await addControl(payload);
            if (response.status === 201) {
                await Toast.fire({
                    title: t('message.addSuccess3', {entity: t('common.control')}), icon: 'success',
                });
                setIsAdding(false);
            }
            await window.location.reload();
            setDisableBtn(false);
        } catch (err) {
            setDisableBtn(false);
            if (err.response.data.code === 'risk_control_name_already_exists_for_specified_risk') {
                await Toast.fire({
                    title: t('controls.controlNameExists'), icon: 'error',
                });
            }
            if (err.response.code === 'file-format') {
                await Toast.fire({
                    title: t('message.fileFormatNotAllowed'), icon: 'error',
                });
            }
            if (err.response.status === 400) {
                await Toast.fire({
                    title: t('message.errorApi'), icon: 'error',
                });
                setIsAdding(false);
            }
        }
    };


    return (<>
        {loading ? (<Spin spinning={loading} size={'large'} className="spinner"/>) : (<>
            {/* <TransitionModal open={}/> */}
            <PreventTransitionPrompt when={isAdding}/>
            <FormProvider {...methods}>
                <form onSubmit={handleSubmit(submitForm)}>
                    <Row className="mb-5 main-form">
                        <Col xs={6} md={6} lg={3}>
                            <label className="label-measures">
                                {t('controls.controlName')}
                            </label>
                            <InputText
                                name="name"
                                className="form-control input-field"
                                placeholder={t('controls.controlNamePlaceholder')}
                                isClearable={false}
                                errors={errors}
                            />
                            <label className="label-measures">
                                {t('controls.controlDescription')}
                            </label>
                            <TextArea
                                name="description"
                                className={`form-control height text-area`}
                                placeholder={t('controls.controlDescriptionPlaceholder')}
                                errors={errors}
                            />
                        </Col>
                        <Col xs={6} md={6} lg={3}>
                            <label className="label-measures">
                                {t('controls.purposeLabel')}
                            </label>
                            <SelectList
                                name="purpose"
                                className="select"
                                options={purposeOptions}
                                placeholder={t('controls.purposePlaceholder')}
                                isClearable={false}
                                errors={errors}
                            />
                            <label className="label-measures">
                                {t('controls.controlType')}
                            </label>
                            <SelectList
                                name="type"
                                className="select"
                                options={controlTypeOptions}
                                placeholder={t('controls.controlTypePlaceholder')}
                                isClearable={false}
                                errors={errors}
                            />
                        </Col>
                        <Col xs={6} md={6} lg={3}>
                            <label className="label-measures">
                                {t('controls.controlFrequency')}
                            </label>
                            <SelectList
                                name="frequency"
                                className="select"
                                options={controlFrequencyOptions}
                                placeholder={t('controls.controlFrequencyPlaceholder')}
                                isClearable={false}
                                errors={errors}
                            />
                            <label className="label-measures">
                                {t('controls.controlEvidence')}
                            </label>
                            <TextArea
                                name="evidence"
                                className="form-control height text-area"
                                placeholder={t('controls.controlEvidencePlaceholder')}
                                errors={errors}
                            />
                        </Col>
                        <Col xs={6} md={6} lg={3}>
                            <label className="label-measures">
                                {t('controls.controlRatePlaceholder')}
                            </label>
                            <SelectList
                                name="controlAssessment"
                                className="select"
                                options={controlAssessmentOptions}
                                placeholder={t('controls.controlRatePlaceholder')}
                                isClearable={false}
                                errors={errors}
                            />
                            <label className="label-measures">
                                {t('controls.department')}
                            </label>
                            <SelectInfinite
                              api={`departments?appModuleId.equals=${appModules?.riskModule}&active.equals=true`}
                              name="department"
                                labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                                className="department"
                                placeholder={t('risk-cosideration.search.organizedUnit')}
                                // defaultValue={{
                                //     value: departmentData[0].id, label: departmentData[0].name,
                                // }}
                                isClearable={false}
                            />
                        </Col>
                    </Row>
                    <Row className="mb-3 pt-3 right-btns">
                        <Col lg={12} className="btns-float-right">
                            <button
                                className="btn btn-cancel btn-strong"
                                type="reset"
                                onClick={toggleOpen}
                            >
                                {t('buttons.cancelBtn')}
                            </button>
                            <button
                                onClick={() => console.log(errors)}
                                type={'submit'}
                                className="btn btn-primary btn-strong"
                                disabled={disableBtn}
                            >
                                {t('buttons.saveBtn')}
                            </button>
                        </Col>
                    </Row>
                </form>
            </FormProvider>
        </>)}
    </>);
}

export default ControlsFormAdd;
